class CartDrawer extends HTMLElement {
    constructor() {
        super();

        document.addEventListener('click', (event) => {
            this.setHeaderCartIconAccessibility(event)
            this.initClose(event)
        })

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.classList.contains('translate-x-full')) {
                this.close()
            }
        })
    }

    setHeaderCartIconAccessibility(event) {
        const cartLink = event.target.closest('#basketIcon');
        if (cartLink) {
            event.preventDefault()
            this.open()
        }
    }

    initClose(event) {
        const close = event.target.closest('#CartDrawer-Overlay') || event.target.closest('.js-cart-drawer-close')
        if (close) this.close()
    }

    open() {
        this.classList.remove('translate-x-full');
        document.getElementById('CartDrawer-Overlay').classList.remove('opacity-0', 'invisible');
        document.body.classList.add('!overflow-hidden');
        setTimeout(() => {
            this.querySelector('button').focus()
        }, 300)
    }

    close() {
        this.classList.add('translate-x-full');
        document.getElementById('CartDrawer-Overlay').classList.add('opacity-0', 'invisible');
        document.body.classList.remove('!overflow-hidden');
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        setTimeout(() => {
            document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.querySelector('.js-cart-drawer-close').addEventListener('click', this.close.bind(this));
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'cart-price',
                section: 'cart-price'
            }
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-price',
                section: 'cart-price',
                selector: '.shopify-section'
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);